module.exports = __webpack_public_path__ + "static/media/AI Scratch.5a63a1c4.png";